import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { I18NextModule } from 'angular-i18next';

@Component({
  selector: 'app-error-with-guide',
  standalone: true,
  templateUrl: './error-with-guide.component.html',
  styleUrls: ['./error-with-guide.component.scss'],
  imports: [CommonModule, I18NextModule]
})
export class ErrorWithGuideComponent {
  @Input() message: string | null = null;
  @Input() messageLogin: string | null = null;
  @Input() messageRestore: string | null = null;
  @Input() showGuideLink = false;
  @Input() guidePath =
    'assets/documents/GUIA_REGISTRO_PSCS_MYGARAGE_250814.pdf';
  @Input() guideFileName = 'GUIA_REGISTRO_PSCS_MYGARAGE_250814.pdf';
  @Input() showRestoreGuideLink = false;
  @Input() restoreGuidePath =
    'assets/documents/GUIA REINICIO USUARIO PSCS MYGARAGE 2025.pdf';
  @Input() restoreGuideFileName =
    'GUIA REINICIO USUARIO PSCS MYGARAGE 2025.pdf';

  downloadLoginGuide() {
    const link = document.createElement('a');
    link.href = this.guidePath;
    link.download = this.guideFileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadRestoreGuide() {
    const link = document.createElement('a');
    link.href = this.restoreGuidePath;
    link.download = this.restoreGuideFileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
